import styled from 'styled-components';

import { StyledActionButton as DefaultStyledActionButton } from './incentive-details.styled.default';

export * from './incentive-details.styled.default';

export const StyledActionButton = styled(DefaultStyledActionButton)`
  font-size: 18px;
  justify-content: center;
`;
